const languages = [
  'en',
  'de',
  'bg',
  'el',
  'es',
  'fi',
  'fr',
  'ga',
  'hu',
  'it',
  'nl',
  'pl',
  'pt',
  'ro',
  'sk',
  'sl',
  'sv',
];

export default languages;
